import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-60d979a8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container-fluild outside-container",
  id: "coreContent"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "bg"
  }, null, -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "container long-container"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "row long-row"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-12 core"
  }, [/*#__PURE__*/_createElementVNode("h2", null, "核心价值观"), /*#__PURE__*/_createElementVNode("h3", null, "BLOODLINE FAMILY"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h5", null, "传播献血大爱，担当社会重责。"), /*#__PURE__*/_createElementVNode("p", null, "“精专传义，血暖京城”。")])])])], -1);
});

var _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}